import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingCart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M13.25 7.25v-2.3c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-.1c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v2.3m-.554 11h7.608c1.197 0 1.796 0 2.24-.239a2 2 0 0 0 .879-.946c.205-.46.16-1.057.072-2.251l-.526-7.1c-.077-1.045-.116-1.567-.344-1.963a2 2 0 0 0-.864-.803c-.412-.198-.935-.198-1.983-.198H6.722c-1.048 0-1.571 0-1.983.198a2 2 0 0 0-.864.803c-.228.396-.267.918-.345 1.963l-.525 7.1c-.089 1.194-.133 1.79.072 2.25a2 2 0 0 0 .88.947c.443.239 1.042.239 2.239.239Z"
	})]
});
const ForwardRef = forwardRef(SvgShoppingCart);
export { ForwardRef as ReactComponent };
